<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: Number, default: null },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const meetingRooms = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value === '' ? null : value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="meeting_rooms"
    >
      <span>{{ trans('addresses.details.form.field.meeting_rooms.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--small input-text">
      <input
        id="meeting_rooms"
        v-model.number="meetingRooms"
        type="number"
        :min="validationRules.min"
        :max="validationRules.max"
        name="meeting_rooms"
        :class="{ error: error !== null }"
        placeholder="0"
        @focusout="$emit('focusout')"
      >
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
